import { useCallback, useRef } from 'react';

export const cancellablePromise = promise => {
  let isCancelled = false;
  const wrappedPromise = new Promise(((resolve, reject) => {
    promise.then(
      value => isCancelled ? reject({ value, isCancelled }) : resolve(value),
      error => reject({ error, isCancelled })
    );
  }))
  return {
    promise: wrappedPromise,
    cancel: () => {
      isCancelled = true;
    }
  }
}

export const useCancellablePromise = () => {
  const promises = useRef([]);

  const addCancellablePromise = useCallback(promise => {
    promises.current = [...promises.current, promise];
  }, []);

  const addNewCancellablePromise = useCallback((timeout) => {
    const newPromise = cancellablePromise(new Promise(resolve => setTimeout(resolve, timeout)));
    promises.current = [...promises.current, newPromise];
    return newPromise;
  }, []);

  const removePendingPromise = useCallback(promise => {
    promises.current = promises.current.filter(p => p !== promise);
  }, []);

  const clearPendingPromises = useCallback(() => {
    promises.current.forEach(p => p.cancel());
  }, []);

  const api = {
    addCancellablePromise,
    removePendingPromise,
    clearPendingPromises,
    addNewCancellablePromise
  }

  return api;
}